import React from 'react';

export const formatDispositionJson =(value: any) => {
  if (value == null) return '';
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || trimmed === '{}' || trimmed === 'null') return '';
    try {
      const parsed = JSON.parse(trimmed);
      if (
        parsed &&
        typeof parsed === 'object' &&
        !Array.isArray(parsed) &&
        Object.keys(parsed).length === 0
      ) {
        return '';
      }
      return JSON.stringify(parsed);
    } catch {
      return trimmed;
    }
  }
  if (typeof value === 'object') {
    if (Array.isArray(value)) return value.length ? JSON.stringify(value) : '';
    return Object.keys(value).length ? JSON.stringify(value) : '';
  }
  return String(value);
};

export const DispositionJsonCell = ({ value }: { value: any }) => {
  const text = formatDispositionJson(value);
  if (!text) return <span>-</span>;
  let parsed: any = null;
  try {
    parsed = JSON.parse(text);
  } catch {
    parsed = null;
  }

  if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
    return (
      <dl className="grid w-full grid-cols-[minmax(110px,auto)_1fr] gap-x-4 gap-y-1.5 rounded-lg border border-border/60 bg-muted/30 px-3 py-2 text-sm">
        {Object.entries(parsed).map(([key, val]) => (
          <React.Fragment key={key}>
            <dt className="font-medium text-muted-foreground">{key}</dt>
            <dd className="break-words font-semibold text-foreground">
              {val == null || val === ''
                ? '-'
                : typeof val === 'object'
                  ? JSON.stringify(val)
                  : String(val)}
            </dd>
          </React.Fragment>
        ))}
      </dl>
    );
  }

  return (
    <pre className="w-full overflow-auto whitespace-pre-wrap break-words rounded-lg border border-border/60 bg-muted/30 px-3 py-2 font-mono text-xs leading-relaxed">
      {parsed ? JSON.stringify(parsed, null, 2) : text}
    </pre>
  );
};
